<template lang="pug">
	modal(:max-width="400")
		.card.text-left
			.card-header.bg-danger.text-white
				span.fa.fa-exclamation-triangle.mr-2
				| Programas en conflicto
			.card-body.bg-light
				p 
					| Se han detectado programas en conflicto. Esto quiere decir que hay programas que coinciden en día y hora con los que 
					| estás tratando de crear.
				p
					| Debes definir una <b>estrategia a seguir</b>
			.card-body(:style="(estrategia === 'sobreescribir') ? {} : {opacity:0.6}")
				.input-group
					.input-group-prepend
						.input-group-text Sobreescribir
					.input-group-append
						button.btn(:class="(estrategia === 'sobreescribir') ? 'btn-primary' : ''", @click="setEstrategia('sobreescribir')")
							span.fa.fa-check
				p
					| La estrategia de <b>sobreescribir</b> eliminará los programas en conflicto en los días seleccionados.
					br
					| Como consecuencia los bloques programados dentro de esas horas quedarán "huérfanos" temporalmente 
					| hasta que crees un programa que los agrupe en ese horario
			.card-body(:style="(estrategia === 'saltar') ? {} : {opacity:0.6}")
				.input-group
					.input-group-prepend
						.input-group-text Saltar
					.input-group-append
						button.btn(:class="(estrategia === 'saltar') ? 'btn-primary' : ''", @click="setEstrategia('saltar')")
							span.fa.fa-check
				p
					| La estrategia de <b>saltar</b> no tocará los programas que coincidan.
					br
					| Como consecuencia de esto no se crearán los nuevos programas en los días que coincidan.
			.card-footer
				button.mr-2.btn.btn-primary(@click="continuar")
					span.fa.fa-check.mr-2
					| Continuar
				button.btn.btn-danger(@click="cancelar")
					span.fa.fa-ban.mr-2
					| Cancelar
</template>


<script>
export default {
	props: ['estrategia'],
	methods: {
		cancelar () {
			this.$emit('update:estrategia', null)
			this.cerrar()
		},
		setEstrategia (dato) {
			this.$emit('update:estrategia', dato)
		},
		continuar () {
			this.$emit('continuar')
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/programas/selecciona-estrategia.vue